import { makeStyles, tokens } from '@fluentui/react-components';

export const useCartStyles = makeStyles({
    cartContainer: {
        width: '100%'
    },
    addButtonsContainer: {
        display: 'flex',
        columnGap: tokens.spacingHorizontalM
    }
});
